export type AppNavigationTab = "journey" | "personality" | "parent" | "coach" | "me";

const APP_PAGES = [
  "/learning-journeys", "/profile", "/parent-dashboard", "/assessment",
  "/refer-and-earn", "/write-to-founder", "/showcase", "/subscription",
];

export function appNavigationTab(pathname: string, hash = ""): AppNavigationTab | null {
  const path = pathname.replace(/\/$/, "");
  // Payment confirmations and the assessment quiz are focused experiences.
  if (!APP_PAGES.some((page) => path === page) && !path.startsWith("/assessment/report/")) return null;
  if (path === "/assessment" || path.startsWith("/assessment/report/")) return "personality";
  if (path === "/parent-dashboard") return "parent";
  void hash; return path === "/learning-journeys" ? "journey" : "me";
}